export class Matricula {
  constructor(
    public possuiMatriculaCalouro: boolean
  ) {}
}

export class RegrasCalouro {
  constructor(
    public Mensagem: string,
	  public isProsseguir: boolean
  ) {}
}



// WEBPACK FOOTER //
// ./src/app/_shared/matricula/matricula.ts